import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {computed, ref} from 'vue';
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {__} from "~/ts/library/Translate";
import OperatorApplicationSwitchConfig from "~/operatorApplication/vue/config/OperatorApplicationSwitchConfig.vue";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";


const __default__ = {
    name: "OperatorApplicationConfigDownload"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

async function selectPath() {
    let path = await OperatorApplicationPlatformFactory.selectDirectory(downloadPath.value);
    if (path) {
        configuration.value.downloadPath = path;
    }
}

let defaultDownloadPath = ref<string>();
(async () => {
    defaultDownloadPath.value = await OperatorApplicationPlatformFactory.getDefaultDownloadPath();
})()

let downloadPath = computed(() => {
    return configuration.value.downloadPath ?? defaultDownloadPath.value;
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: _unref(configuration).isDownloadEnabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(configuration).isDownloadEnabled) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Скачивать файлы через приложение оператора')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(configuration).isDownloadEnabled)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("Путь для скачивания")) + ": ", 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("a", {
                  class: "link-dashed",
                  tabindex: "",
                  onClick: selectPath
                }, _toDisplayString(_unref(downloadPath) ? _unref(downloadPath) : "empty"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})